<template>
<div>
    <stateRestriction v-if="showModel" @close="showModel = false"></stateRestriction>
    <section class="section_checkout-nav">
        <div class="checkout-top-nav-elements">
            <a href="#" class="logo-link w-inline-block"><img sizes="(max-width: 479px) 100vw, 64.421875px" :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-414"></a>
            <div class="form-nav-div-2">
                <a href="#" class="back-link-2 w-inline-block">
                    <div class="text-block-817">&lt;-</div>
                </a>
                <div class="progress-div-2">
                    <div>
                        <div class="step-text">Checkout</div>
                    </div>
                    <div class="progress-precent-div">
                        <div class="percent-prog"></div>
                        <div class="percent-text">% Complete</div>
                    </div>
                </div>
            </div>
            <div class="checkout-help-wrap">

            </div>
        </div>
    </section>
    <section class="section_checkout-body">
        
        <div class="checkout-left-div">
            <div class="checkout-header">Start your health transformation!</div>
            <div class="checkout-sub">Live healthier, stronger and longer with NewSelf.</div>
            <div class="checkout-summary-div mobile">
                <div class="summary-top">
                    <div class="checkout-form-header">Order Summary<br></div>
                    <div class="text-block-819">

                    </div>
                </div>
                <div class="dropdown-sum update">
                    <div class="order-summary-div">
                        <div data-delay="0" data-hover="false" class="order-dropdown w-dropdown">
                            <div class="dropdown-sum-toggle w-dropdown-toggle">
                                <div class="open-drop-text"  @click="orderOpen = !orderOpen">
                                    <div class="text-block-336 step-1 update">Tap to access full order details</div>
                                    <div class="icon-19 w-icon-dropdown-toggle" :class="{ 'w--open': orderOpen }"></div>
                                </div>
                                <!-- Replace static order content with v-for loop -->
                                <div class="order-div" v-for="item in cartFirstItem" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div">
                                                    <img :src="item.image" loading="lazy" :alt="item.name">
                                                </div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{item.name}}</div>
                                                <div class="text-block-850">{{ item.subheader }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{ item.retail_price }}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block" @click.prevent="removeFromCart(item.id)">
                                        <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="">
                                    </a>
                                </div>
                            </div>
                            <nav class="dropdown-summary w-dropdown-list" :class="{ 'w--open': orderOpen }">
                                <div class="order-div" v-for="item in cartItemsMinusFirst" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div"><img :src="item.image" loading="lazy" :alt="item.name"></div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{item.quantity}}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{item.name}} <br></div>
                                                <div class="text-block-850">{{item.subheader}}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{item.price}}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{item.retail_price}}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block"><img src="@/assets/images/icon_trash.svg" loading="lazy" alt=""></a>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822">${{ getDiscount.toFixed(2) }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ finalTotal.toFixed(2) }}</div>
                </div>
                <div class="summary-sub"><br/></div>
                <form style="width: 100%; display: flex;" @submit.prevent="handleCouponSubmit">
                <div class="promo-div-2" style="width: 100%;">
                    <div class="form-block-11 checkout w-form">
                        
                            <input class="tf_textfield-3 promo checkout w-input" v-model="couponInput" maxlength="256" name="Promo-Code-2" data-name="Promo Code 2" placeholder="Promo Code" type="text" id="Promo-Code-2" required="">
                            <div class="w-form-fail" style="display: block;" v-if="errorMessage">
                            <div>{{errorMessage}}</div>
                        </div>
                    </div>
                    <div class="promo-button-div">
                        <button type="submit" class="checkout-button-3 promo w-button">SUBMIT</button>
                    </div>
                </div>
            </form>
            </div>
           
            <div class="card-div">
                <div class="text-block-705">Express Payment</div>
                <div class="express-element-container">
                    <div id="applepaybutton" style="width:45%;"></div>
                    <div id="googlepaybutton" style="width:45%;"></div>
                </div>
                
                <div class="card-form w-form">
                    <div class="card-top-div">
                            <div class="text-block-707">Credit card</div>
                            <div class="cards-div"><img width="Auto" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a666ac0b6038a820d99_visa.png" class="image-416"><img width="35" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a666ac0b6038a820d3d_mastercard.png" class="image-416"><img width="35" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a676ac0b6038a820dc2_AmEx.png" class="image-416"><img width="35" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a666ac0b6038a820d29_discover.png" class="image-416"></div>
                        </div>
                        <div class="card-fields-div">
                            <div class="address-div" style="width:100%">
                                <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                            </div>
                            <div id="card-element" class="ns-card-element" ref="myElement"></div>
                            
                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I have read and agree to the website <a href="https://newselfrx.com/returns-and-refund" target="_blank">Refund Policy</a> and <a href="https://newselfrx.com/terms-of-use" target="_blank">Terms and Conditions</a></span>
                            </label>
                            
                            <!--<label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I agree to the <a href="https://newselfrx.com/terms-of-use" target="_blank">Terms of Use</a>, <a href="https://newselfrx.com/privacy-policy" target="_blank">Privacy Policy</a>, <a href="https://newselfrx.com/hipaa" target="_blank">HIPPA Notice</a> and <a href="https://newselfrx.com/telehealth-consent" target="_blank">Telehealth Consent</a></span>
                            </label>
                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I certify that I am at least 18 years of age</span>
                            </label>
                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I agree to be billed for ${{finalTotal}} the first month and ${{parseFloat(cartTotalNoDiscount)}} for each month thereafter until canceled. If I cancel after the first month i will forfeit the discount and be charged the full price. <a href="#">Terms of condition</a> of this program</span>
                            </label>-->
                        </div>
                        <div class="apple-pay-radio-div"><label class="w-radio"><input type="radio" name="radio-2" id="radio-2" data-name="Radio 2" class="w-form-formradioinput w-radio-input" value="Radio 2"><span class="w-form-label" for="radio-2">Apple Pay</span></label><img loading="lazy" src="@/assets/images/Apple_Pay_logo.svg" alt="" class="image-415"></div>
                    
                        <div class="w-form-fail" style="display:block" v-if="paymentError">
                                <div>{{ errorMessage }}.</div>
                        </div>
                </div>
            </div>
            <a class="checkout-button-3 w-button fixmobile changecolor" @click.prevent="getStripeToken()">
                <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                <span v-else>Pay Now</span>
            </a>
        
            <div class="desktop-pay-button-div">
                <div class="div-block-1763">
                    <div class="text-block-820">In order for us to send you your medication, you MUST complete the brief medical form immediately after checking out.</div>
                </div>
                <div class="secure-payment-div"><img width="130" loading="lazy" alt="" src="@/assets/images/paymentsecure.422c0e1.png"></div>
            </div>
        </div>
        <div class="checkout-right-div">
            <div class="mobile-pay-button-div">
                <div class="div-block-1763">
                    <div class="text-block-820">In order for us to send you your medication, you MUST complete the brief medical form immediately after checking out.</div>
                </div>
                <div class="secure-payment-div"><img width="130" loading="lazy" alt="" src="@/assets/images/paymentsecure.422c0e1.png"></div>
            </div>
            <div class="checkout-summary-div desktop">
                <div class="summary-top">
                    <div class="checkout-form-header box">Order summary<br></div>
                    <div class="text-block-819"></div>
                </div>
                <div class="dropdown-sum update">
                    <div class="order-summary-div">
                        <div data-delay="0" data-hover="false" class="order-dropdown w-dropdown">
                            <div class="dropdown-sum-toggle w-dropdown-toggle">
                                <!-- Replace static order content with v-for loop -->
                                <div v-for="item in cartItems" :key="item.id" class="order-div">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div">
                                                    <img :src="item.image" loading="lazy" :alt="item.name">
                                                </div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{ item.name }}<br></div>
                                                <div class="text-block-850">{{ item.subheader }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{ item.retail_price }}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block" @click.prevent="removeFromCart(item.id)">
                                        <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="">
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822">${{ getDiscount.toFixed(2) }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ finalTotal.toFixed(2) }}</div>
                </div>
                <div class="summary-sub"><br/></div>
                <form style="width: 100%; display: flex;" @submit.prevent="handleCouponSubmit">
                <div class="promo-div-2" style="width: 100%;">
                    <div class="form-block-11 checkout w-form">
                        <input class="tf_textfield-3 promo checkout w-input" v-model="couponInput" maxlength="256" name="Promo-Code-2" data-name="Promo Code 2" placeholder="Promo Code" type="text" id="Promo-Code-2" required="">
                        
                        <div class="w-form-fail" style="display: block;" v-if="errorMessage">
                            <div>{{errorMessage}}</div>
                        </div>
                    </div>
                    <div class="promo-button-div">
                        <button type="submit" class="checkout-button-3 promo w-button">SUBMIT</button>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </section>
</div>
</template>
<script>
import {
    BasisTheory
} from "@basis-theory/basis-theory-js";
const bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, {
    elements: true
});

import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
import stateRestriction from '../common/stateRestriction.vue'
import coupons from "@/utils/coupons.json"
import {
    mapGetters,
    mapActions
} from 'vuex';

export default {
    name: 'CheckoutComponent',
    components: {
        GooglePlacesAutocomplete,
        stateRestriction
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            orderOpen: false,
            all_coupons: coupons,
            submitted: false,
            paymentError: false,
            showModel: false,
            stripe: null,
            card: null,
            elements: null,
            expressCheckoutElement: null,
            user: null,
            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            // CHANGED: Added cartItems to paymentInfo to track cart state
            paymentInfo: {
                id: '',
                cardToken: '',
                amount: 499,
                discount: 0,
                medication: '',
                couponCode: '',
                drug_mode: '',
                couponId: null, // CHANGED: Initialize as null instead of hardcoded value
                paymentMethod: null,
                cartItems: [], // NEW: Array to store cart items for backend
                cardDetails:[],
            },
            couponValid: true,
            couponApplied: false,
            errorMessage: '',
            stripeInitialized: false,
            couponInput:'',
        };
    },
    computed: {
        ...mapGetters([
            'cartItems',
            'cartTotal',
            'cartDiscount',
            'cartTotalNoDiscount',
        ]),
        canSubmit() {
            return this.cartItems.length > 0 &&
                this.termsAccepted &&
                this.ageVerified &&
                this.customerInfo.addressLine1 &&
                this.customerInfo.city &&
                this.customerInfo.state &&
                this.customerInfo.zip;
        },
        // UPDATED: Modified to use backend-provided discount
        finalTotal() {
            if(this.couponApplied){
                return this.cartTotalNoDiscount - this.paymentInfo.discount
            }
            return this.cartTotal;
        },
        amountInCents() {
            return Math.round(this.finalTotal * 100);
        },
        // UPDATED: Modified to use backend-provided discount
        getDiscount(){
            if(this.couponApplied){
                return this.paymentInfo.discount
            }
            return this.cartDiscount;
        },
        cartFirstItem() {
            try {
                return [this.cartItems[0]];
            } catch (error) {
                return [];
            }
        },
        cartItemsMinusFirst() {
            let temp = this.cartItems;
            return temp.slice(1);
        }
    },
    watch: {
        // NEW: Watch for cart changes to update paymentInfo
        cartItems: {
            handler(newItems) {
                this.updatePaymentInfoCart(newItems);
            },
            deep: true,
            immediate: true
        },
        '$refs.card'(newVal) {
            if (newVal && !this.stripeInitialized) {
                this.initializeStripeElements();
            }
        },
        '$refs.expresscheckoutelement'(newVal) {
            if (newVal && this.stripe && !this.expressCheckoutElement) {
                this.initializeExpressCheckout();
            }
        }
    },
    async mounted() {

        this.createCardElement();
        this.addScriptOnHead();
        try {
            
            this.checkRouteForDiscount();
            
        } catch (error) {
            console.error('Error initializing Stripe:', error);
            this.errorMessage = 'Failed to initialize payment system';
        }
    },
    methods: {
        ...mapActions([
            'removeFromCart',
            'updateCartQuantity',
            'clearCart'
        ]),
        addScriptOnHead(){
            this.removeOldCollectJsScript(); // Ensure no duplicate scripts
            const script = document.createElement('script');
            script.src = "https://secure.safewebservices.com/token/Collect.js";
            script.setAttribute("data-tokenization-key", "U8egYM-37U3j5-64Ba82-3Bg6DZ");
            script.setAttribute("data-country", "US");
            script.setAttribute("data-currency", "USD");
            document.head.appendChild(script);

            script.onload = () => {
                console.log("Collect.js script loaded successfully.");
                this.initializeCollectJS();
            };
            script.onerror = () => {
                console.error("Failed to load Collect.js script.");
            };
        },
        removeOldCollectJsScript() {
            const existingScript = document.querySelector('script[src="https://secure.safewebservices.com/token/Collect.js"]');
            if (existingScript) {
                existingScript.remove();
            }
        },
        initializeCollectJS() {
            let lineItems = this.paymentInfo.cartItems.map(item => ({
                label: item.name.toString(),
                amount: (Math.round(item.price * 100)).toString()  // Convert the amount to a string
            }));
            let vm = this;
            window.CollectJS.configure({
                'theme': 'bootstrap',
                'fields': {
                    'applePay' : {
                        'shippingMethods': [
                            {
                                'label': 'Express Shipping',
                                'amount': '0.00',
                                'detail': 'Arrives overnight',
                                'identifier': 'expressShipping'
                            }
                        ],
                        'shippingType': 'delivery',
                        'requiredBillingContactFields': [
                            'postalAddress',
                            'name'
                        ],
                        'requiredShippingContactFields': [
                            'postalAddress',
                            'name'
                        ],
                        'contactFields': [
                            'phone',
                            'email'
                        ],
                        'contactFieldsMappedTo': 'shipping',
                        'lineItems': lineItems,
                        'totalLabel': 'Total Amount Due',
                        'totalType': 'pending',
                        'type': 'buy',
                        'style': {
                            'height': '40px',
                        }
                    },
                    'googlePay': {
                        'shippingAddressRequired': true, // Whether shipping address is required
                        'shippingAddressParameters': {
                            'phoneNumberRequired': true, // Whether phone number is required
                            'allowedCountryCodes': ['US'] // Restrict countries for shipping
                        },
                        'billingAddressRequired': true, // Whether billing address is required
                        'billingAddressParameters': {
                            'phoneNumberRequired': true, // Whether phone number is required
                            'format': 'MIN' // Address format: 'MIN' or 'FULL'
                        },
                        'emailRequired': true, // Require email address
                        'buttonType': 'plain', // Button type: 'buy' or 'plain'
                        'buttonColor': 'default', // Button color: 'default', 'black', 'white'
                        'buttonLocale': 'en', // Language locale for the button
                        
                    }
                },
                'price': this.finalTotal.toString(),
                'currency':'USD',
                'country': 'US',
                'callback' : function(response) {
                    console.log(JSON.stringify(response))
                    vm.extractPaymentData(response);
                }
            });
        },

        extractPaymentData(response) {
            try {
                this.paymentInfo.paymentMethod=response.tokenType;
                this.paymentInfo.cardToken = response.token || null;
                const shippingInfo = (response.wallet?.shippingInfo || response.shippingInfo) || {};

                this.customerInfo.addressLine1= shippingInfo.address1 || shippingInfo.street || '';
                this.customerInfo.city=shippingInfo.city || '';
                this.customerInfo.state=shippingInfo.state || '';
                this.customerInfo.zip=shippingInfo.postalCode || '';

            } catch (error) {
                console.error('Error extracting payment data:', error);
                return null;
            }
        },
        
        createCardElement() {
            this.cardElement = bt.createElement('card');
            this.cardElement.mount('#card-element');
        },
        // NEW: Method to update cart items in paymentInfo
        updatePaymentInfoCart(items) {
            this.paymentInfo.cartItems = items.map(item => ({
                id: item.id,
                quantity: item.quantity,
                price: item.price,
                name: item.name,
                retail_price: item.retail_price,
            }));
        },

        // UPDATED: Modified coupon submission to include cart items
        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.couponInput) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            this.paymentInfo.couponCode = this.couponInput;
            await this.validateCoupon();
        },

        // UPDATED: Modified to send cart items with coupon validation
        async validateCoupon() {
            if (this.couponApplied) return;

            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    cartItems: this.paymentInfo.cartItems // Send cart items for validation
                });
                
                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    this.paymentInfo.discount = response.data.c_val;
                    await this.initializeExpressCheckout();
                } else {
                    this.couponValid = false;
                    this.errorMessage = response.data.message || 'Invalid Coupon.';
                }
            } catch (error) {
                console.error('Error validating coupon:', error);
                this.errorMessage = 'An error occurred while validating the coupon.';
                this.couponValid = false;
            }
        },

        
        checkRouteForDiscount() {
            this.user = this.$store.getters.user;
            this.customerInfo.id = this.user.id;
            this.paymentInfo.id = this.user.id;
            this.paymentInfo.drug_mode = "Vile"
        },

        getAddressData(address) {
           
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                this.updateAddress();
        },

        async updateAddress() {
            try {
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                throw new Error('Failed to update address');
            }
        },

        getStripeToken() {
            this.submitted = true;
            this.paymentError = false;
            if (this.customerInfo.zip === '' || this.customerInfo.zip == null) {
                this.paymentError = true;
                this.errorMessage = "Please enter valid address.";
                this.submitted = false;
                return false;
            }
            this.errorReason = false;
            bt.tokens
                .create({
                    type: "card",
                    data: this.cardElement,
                })
                .then((token) => {
                    this.paymentInfo.cardToken = token.id;
                    this.paymentInfo.cardDetails = token.data;
                    this.paymentInfo.paymentMethod = 'card';
                    this.processPayment();
                })
                .catch((error) => {
                    console.log(error);
                    this.paymentError = true;
                    this.errorMessage = "Invalid card details";
                    this.submitted = false;
                });
        },
        async sendRequest(paymentData){
           let response = await this.$axios.post(`${this.baseUrl}/api/checkout-new`, paymentData)
           return response;
        },
        // UPDATED: Modified to send complete cart information
        async processPayment() {
            try {
                this.paymentError = false;
                const paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: this.cartTotal,
                    cartTotalNoDiscount: this.cartTotalNoDiscount
                };

                const response = await this.sendRequest(paymentData);
                
                if (response.data.status === 'success') {
                    console.log(response.data)
                    // Store in Vuex
                    await  this.$store.dispatch('setPrescriptionPreauths', response.data.prescriptionPreauths);
                    await this.updateAddress();
                    await this.clearCart(); // NEW: Clear cart after successful payment
                    this.pushToRoute();
                    this.submitted = false;
                } else {
                    this.paymentError = true;
                    this.errorMessage = response.data.message || 'Payment processing failed';
                    this.submitted = false;
                }
            } catch (error) {
                console.error('Error processing payment:', error);
                this.paymentError = true;
                this.errorMessage = error.message || 'Failed to process payment';
                this.submitted = false;
            }
        },

        pushToRoute() {
            this.$router.push({
                name: 'prescriptionThanks',
            });
        },

        beforeDestroy() {
            if (this.card) {
                this.card.destroy();
            }
            if (this.expressCheckoutElement) {
                this.expressCheckoutElement.destroy();
            }
        }
    }
};
</script>

<style scoped>
.myelement {
    border: 1px solid #002646;
    border-radius: 6px;
    padding: 5px 0 5px 15px;
    display: block;
    width: 100%;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 1.42857143;
    color: #333333;
    background-color: #ffffff;
}
.changecolor{
    background-color: var(--light-green);
}
.link-block-43{
    background-color: #fff;
}
.my-input {
    padding: 15px;
    border: 1px solid black;
    border-radius: 9px;
    margin-bottom: 15px;
    height: '55px';
}

.tf_textfield.w-input.StripeElement {
    align-content: center;
}

.strikethrough {
    text-decoration: line-through;
    text-decoration-color: red;
    text-decoration-thickness: 2px;
}

.promo-div {
    justify-content: space-between;
    display: block;
}

.form-block-10.checkout {
    width: 100%;
    display: flex;
    gap: 10px;
}
@media screen and (max-width: 479px) {
    .checkout-summary-div.mobile {
        background-color: #fff;
    }
    .order-div {
        background-color: #fff;
    }
    .order-summary-div {
        background-color: #fff;
    }
    .fixmobile{
        margin-top:95px !important;
    }
}
</style>
